<template>
    <div>

        <div class="view">

            <Head @ck="menuOpen = true">{{ headTxt}}</Head>
            <router-view></router-view>
        </div>

    </div>
</template>

<script>
import mainDelegate from '@/delegate/mainDelegate'
export default {
    name: 'Demo',
    mixins: [mainDelegate],
    computed: {
        headTxt() {
            if (this.$route.name === 'main') {
                return this.$t('menu.toDay')
            }
            if (this.$route.name === 'exercise') {
                return this.$t('menu.toWord')
            }
            return this.$t('menu.practice')
        }
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
@import 'view.less';
</style>



// WEBPACK FOOTER //
// src/page/Today.vue